<template>
  <div>
    <v-dialog v-model="dialogComputed" scrollable>
      <v-card v-if="dialogComputed">
        <v-card-title class="primary white--text py-2">
          {{ $t('ELE0491') }}
          <v-spacer />
          <Btn icon="mdi-close" @click="onClickClose" depressed iconProp color="white" />
        </v-card-title>
        <v-container fluid>
          <v-card flat>
            <v-row>
              <v-col cols="3">
                <TextFieldRef :label="$t('ELE0048')" :value="inspCompanyCd + ' : ' + inspCompanyName" />
              </v-col>
              <v-col cols="3">
                <TextFieldRef :label="$t('ELE0031')" :value="partCd" />
              </v-col>
              <v-col cols="3">
                <TextFieldRef :label="$t('ELE0049')" :value="lotNo" />
              </v-col>
              <v-col cols="3">
                <TextFieldRef :label="$t('ELE0137')" :value="inspIndexNo" />
              </v-col>
            </v-row>
          </v-card>
          <v-card outlined>
            <v-card-title>
              {{ $t('ELE0023') }}
            </v-card-title>
            <v-card-text>
              <v-data-table :headers="headers" :items="items" dense>
                <template v-slot:item.mmmmNo="{ item }">
                  <BtnLink :label="item.mmmmNo" @click="onClick4MLink(item.mmmmNo)" />
                </template>
                <template v-slot:item.dispositionCd="{ item }">
                  <td class="v-data-table__divider">{{ getEnumlang('MmmmDispositionCd.', item.dispositionCd) }}</td>
                </template>
                <template v-slot:item.statusCd="{ item }">
                  <td class="v-data-table__divider">{{ $t(`MmmmApprovalStatusCd.${item.statusCd}`) }}</td>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
        </v-container>
      </v-card>
    </v-dialog>
    <v-dialog v-if="mmmmDialog" v-model="mmmmDialog" scrollable>
      <v-card>
        <v-card-title class="primary white--text py-2">
          {{ $t('ELE0491') }}
          <v-spacer />
          <Btn icon="mdi-close" @click="mmmmDialog = false" depressed iconProp color="white" />
        </v-card-title>
        <v-card-text>
          <MmmmRequestForm :propsMmmmNo="selected4MLink" isModal @close="onCloseMmmmDialog" />
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { API } from '@/plugins/api'
import APIUtils from '@/mixin/api-utils.js'
import Message from '@/mixin/message-utils.js'
import Loading from '@/mixin/loading-utils.js'
import DateUtils from '@/mixin/date-utils.js'

import Btn from '@/components/atoms/base/button/Btn'
import BtnLink from '@/components/atoms/base/button/BtnLink'
import TextFieldRef from '@/components/atoms/base/text-field/TextFieldRef'
import MmmmRequestForm from '@/components/organisms/terminal/form/MmmmRequestForm.vue'

export default {
  name: 'SearchMmmmSubDialog',

  mixins: [APIUtils, Message, Loading, DateUtils],

  components: {
    Btn,
    BtnLink,
    TextFieldRef,
    MmmmRequestForm,
  },

  props: {
    dialog: {
      type: Boolean,
      default: false,
      required: true,
    },
    inspCompanyCd: {
      type: String,
      required: false,
    },
    inspCompanyName: {
      type: String,
      required: true,
    },
    lotNo: {
      type: String,
      required: true,
    },
    partCd: {
      type: String,
      required: true,
    },
    inspIndexNo: {
      type: String,
      required: true,
    },
  },

  computed: {
    dialogComputed: {
      get() {
        return this.dialog
      },
      set(value) {
        this.$emit('update:dialog', value)
      },
    },
  },

  data() {
    return {
      items: [],
      headers: [
        { text: this.$t('ELE0052'), value: 'mmmmNo', divider: true },
        { text: this.$t('ELE0420'), value: 'statusCd', divider: true },
        { text: this.$t('ELE0505'), value: 'dispositionCd', divider: true },
      ],
      mmmmDialog: false,
      selected4MLink: null,
    }
  },

  methods: {
    getEnumlang(key, value) {
      // langのenumからメッセージ取得
      let lang = ''
      if (value) {
        lang = this.$t(key + value)
      }
      return lang
    },
    onClickClose() {
      this.dialogComputed = false
    },
    onCloseMmmmDialog() {
      this.mmmmDialog = false
      this.search()
    },
    onClick4MLink(mmmmApplNo) {
      this.selected4MLink = mmmmApplNo
      this.mmmmDialog = true
    },
    async search() {
      this.startLoading()
      try {
        const params = {
          inspIndexNo: this.inspIndexNo,
        }
        this.items = []
        this.items = await API.get('/mmmm/inspIndexes', params)
      } catch (error) {
        this.items = []
        this.setErrorMessage(this.resolveErrorMessage(error, this.$t('MSG0002', { p0: this.$t('ELE0078') })))
      } finally {
        this.stopLoading()
      }
    },
  },

  mounted() {
    this.search()
  },
}
</script>
